"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Determines if a string is an email address as opposed to an address domain
 * @param text - contains either a valid email address or a valid address domain
 */
function isEmailAddress(text) {
    return text.indexOf('@') !== -1;
}
exports.default = isEmailAddress;
//# sourceMappingURL=isEmailAddress.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-mail-option-common/lib/utils/isEmailAddress.js
// module id = 5029
// module chunks = 2